export const metricsConstants = {
  GET_YEAR_METRICS: 'GET_YEAR_METRICS',
  GET_RANGE_METRICS: 'GET_RANGE_METRICS',
  GET_DRIVER_METRICS: 'GET_DRIVER_METRICS',
  GET_COMPANY_METRICS: 'GET_COMPANY_METRICS',
  GET_COMPANY_PROJECTION: 'GET_COMPANY_PROJECTION',
  GET_VEHICLE_METRICS: 'GET_VEHICLE_METRICS',
}
